import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const addWorkShift: any = createAsyncThunk<any>(
	'addWorkShift',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/salesPersonTrackingService/configuration',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const editWorkShift: any = createAsyncThunk<any>(
	'editWorkShift',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put(
				'/salesPersonTrackingService/configuration',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getWorkShift: any = createAsyncThunk<any>(
	'getWorkShift',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/salesPersonTrackingService/configuration',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const deleteWorkShift: any = createAsyncThunk<any>(
	'deleteWorkShift',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.delete(
				'/salesPersonTrackingService/configuration',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getWorkShiftSalesPerson: any = createAsyncThunk<any>(
	'getWorkShiftSalesPerson',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/salesPersonTrackingService/configuration/assignSalesPersonWorkTime',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const addObjective: any = createAsyncThunk<any>(
	'addObjective',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/salesPersonTrackingService/configuration/objective',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const editObjective: any = createAsyncThunk<any>(
	'editObjective',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put(
				'/salesPersonTrackingService/configuration/objective',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getVisits: any = createAsyncThunk<any>(
	'getVisits',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/salesPersonTrackingService/configuration/visits',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const deleteObjective: any = createAsyncThunk<any>(
	'deleteObjective',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.delete(
				'/salesPersonTrackingService/configuration/objective',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const updateVisit: any = createAsyncThunk<any>(
	'updateVisit',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put(
				'/salesPersonTrackingService/configuration/visits',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getTrackingMapsList: any = createAsyncThunk<any>(
	'getTrackingMapsList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/salesPersonTrackingService/tracking/map',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getTrackingVisitsList: any = createAsyncThunk<any>(
	'getTrackingVisitsList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/salesPersonTrackingService/tracking/visit',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getTrackingTimesheetList: any = createAsyncThunk<any>(
	'getTrackingTimesheetList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/salesPersonTrackingService/tracking/report',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getTrackingTimesheetDetails: any = createAsyncThunk<any>(
	'getTrackingTimesheetDetails',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/salesPersonTrackingService/tracking/detailedReport',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getCurrentDateVisitDetails: any = createAsyncThunk<any>(
	'getCurrentDateVisitDetails',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/salesPersonTrackingService/tracking/report',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getUniqueVisit: any = createAsyncThunk<any>(
	'getUniqueVisit',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/salesPersonTrackingService/tracking/uniqueVisit',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getUniqueVisitCount: any = createAsyncThunk<any>(
	'getUniqueVisitCount',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/salesPersonTrackingService/tracking/uniqueVisit/count',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getStandsListAPI: any = createAsyncThunk<any>(
	'getStandsListAPI',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('/salesPersonTrackingService/stand', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getAssignStandsListAPI: any = createAsyncThunk<any>(
	'getAssignStandsListAPI',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/salesPersonTrackingService/stand/assign',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const checkExistingModelNoAPI: any = createAsyncThunk<any>(
	'checkExistingModelNoAPI',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/salesPersonTrackingService/stand/existModelNumber',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const addStandAPI: any = createAsyncThunk<any>(
	'addStandAPI',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/salesPersonTrackingService/stand',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const editStandAPI: any = createAsyncThunk<any>(
	'editStandAPI',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put(
				'/salesPersonTrackingService/stand',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const addAssignStandAPI: any = createAsyncThunk<any>(
	'addAssignStandAPI',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/salesPersonTrackingService/stand/assign',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const updateAssignedStandStatusAPI: any = createAsyncThunk<any>(
	'updateAssignedStandStatusAPI',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.patch(
				'/salesPersonTrackingService/stand/assign',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const downloadStandLabelAPI: any = createAsyncThunk<any>(
	'downloadStandLabelAPI',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/salesPersonTrackingService/stand/generateLabel',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getUpdateStandsListAPI: any = createAsyncThunk<any>(
	'getUpdateStandsListAPI',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/salesPersonTrackingService/stand/updates',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getAbsenceList: any = createAsyncThunk<any>(
	'getAbsenceList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/salesPersonTrackingService/tracking/absenceList',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);